import React from "react";
import SendSmsIcon from "assets/images/sms-message-icon.png";

const SmsButton = ({ btnText, formUrl }) =>  (
	<a
		className="flex border w-fit px-3 py-2 justify-between items-end hover:bg-gray-50 transition-colors"
		href={formUrl}
		target="_blank"
		rel="noreferrer"
		aria-label={`${btnText} (opens in new tab)`}
	>
		<img className="size-6 mr-2" src={SendSmsIcon} alt="SMS" role="presentation" aria-hidden="true" />
		{btnText}
	</a>
);

export default SmsButton;